<!-- Loading Overlay para validación de credenciales -->
@if(isValidatingCredentials) {
  <div class="global-loading-overlay">
    <div class="loading-content">
      <mat-spinner diameter="60"></mat-spinner>
      <p>Validando credenciales...</p>
    </div>
  </div>
}

<router-outlet></router-outlet>
